declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: {
            client_id: string;
            callback: (response: { credential: string }) => void;
          }) => void;
          renderButton: (element: HTMLElement, options: object) => void;
        };
      };
    };
  }
}

const GOOGLE_GSI_SCRIPT_SELECTOR = 'script[data-google-gsi-script="true"]';
let googleGsiLoader: Promise<void> | null = null;

export function getGoogleAccountsId() {
  return window.google?.accounts?.id ?? null;
}

export function loadGoogleIdentityServices(): Promise<void> {
  if (getGoogleAccountsId()) return Promise.resolve();

  if (!googleGsiLoader) {
    googleGsiLoader = new Promise((resolve, reject) => {
      let script = document.querySelector<HTMLScriptElement>(GOOGLE_GSI_SCRIPT_SELECTOR);
      if (script?.dataset.loaded === "error") { script.remove(); script = null; }
      const el = script ?? document.createElement("script");

      const cleanup = () => {
        el.removeEventListener("load", onLoad);
        el.removeEventListener("error", onErr);
      };
      const onLoad = () => {
        el.dataset.loaded = "true";
        cleanup();
        if (getGoogleAccountsId()) { resolve(); } else { reject(new Error("GIS init failed")); }
        googleGsiLoader = null;
      };
      const onErr = () => {
        el.dataset.loaded = "error";
        cleanup();
        googleGsiLoader = null;
        reject(new Error("GIS load failed"));
      };

      if (getGoogleAccountsId()) { resolve(); return; }
      if (el.dataset.loaded === "true") { reject(new Error("GIS not init")); return; }

      el.addEventListener("load", onLoad);
      el.addEventListener("error", onErr);

      if (!script) {
        el.src = "https://accounts.google.com/gsi/client";
        el.async = true;
        el.defer = true;
        el.dataset.googleGsiScript = "true";
        el.dataset.loaded = "loading";
        document.head.appendChild(el);
      }
    });
  }

  return googleGsiLoader;
}
